import type {FieldTypeId} from 'src/typings';
import type {FieldTypeDefinition, FondFieldTypeDefinitions} from './types';
import {exists} from 'src/shared/utils/custom-utils';

export function getFieldTypeDefinitionRecursively(fieldTypeDefinitions: FondFieldTypeDefinitions, fieldTypeId: FieldTypeId): FieldTypeDefinition | null {
    if (fieldTypeDefinitions.fieldTypes.length === 0) {
        return null;
    }

    const fieldTypeDef = fieldTypeDefinitions.fieldTypes.find((fieldType) => fieldType.id === fieldTypeId);

    if (exists(fieldTypeDef)) {
        return fieldTypeDef;
    }

    for (const fieldType of fieldTypeDefinitions.fieldTypes) {
        const subfieldTypeDef = getFieldTypeDefinitionRecursively(fieldType, fieldTypeId);

        if (exists(subfieldTypeDef)) {
            return subfieldTypeDef;
        }
    }

    return null;
}